import React from 'react';
import { useState } from 'react';
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import { withRouterJim } from "router/withRouterJim";
import NuLoading from 'components/nubox/NuLoading'; 
import { NotificationContainer, NotificationManager } from 'react-notifications';

import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
} from "reactstrap";
//----------------------------------------------


//-----------------------------------------------
class Box_buscar_materia extends  React.Component {
  state={
    data:[],
    key:'',
 
    form:{},
    isLoading:false,
  }

  componentDidMount(){
    //this.setState({isLoading:true});
    //console.log(this.state);
  }
    //---funcion de busqueda
    
  //-------------------------------------------------
  //--cambiamos la fecha
  handleChangeKey = (event)=> {    
    this.setState({ key:event.target.value }); 
  }
  //-------------------------------------------------
  onSubmit=(e)=>{
    e.preventDefault();
    this.buscar();
  }
  //-------------------------------------------------
  buscar=(e)=>{
    e.preventDefault();
    //--validacion 
    if(this.state.key.length<3 && this.state.key.length!==0 ){
      NotificationManager.error("3 caracters minimo");
      return;
    }
    //---colocamos el loading
    this.setState({isLoading:true});
    //--limpiamos antes de cargar nuevamente
    this.setState({data:[]});
    
    //-cargamos la tabla
    let param = { 
      key: this.state.key,
    }
    /*[{
          "id_cliente": 0,
          "razon_social": "GENERAL"
      },] */
    axios2.post("box_buscar_materia_find", param).then(res => {
        this.setState({isLoading:false});

        if(res.data.length>0){ 
            
              this.setState({ data:res.data })
        }else{
            NotificationManager.error("No existen registros");
        }
        
    }).catch(error => {
        //if(error.response.status && error.response.status===400)
        NotificationManager.error("Bad Request");
        console.log(error);
        
    });
  }
  //--------------------------------------------------
  
  render() {
    
    return (
      
      <div >
        <NotificationContainer/>
        <Modal isOpen={this.props.modalOpen}>
            <ModalHeader toggle={this.props.toggle} style={{ }}>
              Busqueda
            </ModalHeader>

            <ModalBody>
            <form name="form1" id="form1" action="" onSubmit={this.onSubmit}>
              <table  align="center" style={{width: "100%"}}>
                <tbody>
                  <tr>
                    <td width="34%" className="celta class_rigth captionPie"></td>
                    <td width="29%" className="captionPie">
                      <input  name="key" type="text" 
                              value={ this.state.key } 
                              onChange={ this.handleChangeKey } 
                              />
                    </td>
                    <td width="37%"  className="captionPie" align="center">
                      <button onClick={(e)=>this.buscar(e)}>Buscar</button>
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="3" className="infocafe" height="25">
                      <NuLoading isLoading={this.state.isLoading} type="1" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </form>  
            {/* ---TABLA ---- */}
            <div style={{border:"solid 1px #69C"}}>
              <div className="co-xs-8 col-xs-offset-2 well" >
                <div className="table-wrapper-scroll-y my-custom-scrollbar" 
                     style={{ height: "350px",overflow: 'auto' }}>
                  <table id="tabla01" className='table table-scroll table-striped table-hover' width='100%' align='center'>

                    <thead>
                      <tr>
                        <th style={{ width: "80px" }}>Codigo</th>
                        <th>Sigla</th>
                        <th>Nombre</th>
                        <th>Grupo</th>
                      </tr>
                    </thead>

                    <tbody>
                    { this.state.data.map((item, index) => (
                      <tr key={index}>
                        <td>{item.id_mate}</td>
                        <td>{item.sigla}</td>
                        <td>{item.nombre}</td>
                        <td>{item.id_grupo}</td>
                        <td>
                          <Button color="info" onClick={()=> this.props.hancleClick(item)}>OK</Button>
                        </td>
                      </tr>
                    ))} 
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
  
            </ModalBody>

            <ModalFooter>

              <button className="btn btn-success" onClick={()=>this.props.handlesave()}>
                Guardar
              </button>
              <button className="btn btn-danger" onClick={()=> this.props.toggle()}>Cancelar</button>
            </ModalFooter>
        </Modal>  
      </div>
    )
  }
}


//------------para que soporte la funcionalidad de parametros
export default withRouterJim(Box_buscar_materia);